export default __webpack_public_path__ + "static/media/institute-29-min.ea589129.webp";